import * as React from 'react';
import { Sparkles } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface Props {
  module: string;
  description: string;
  comingIn: string;
  features?: string[];
  children?: React.ReactNode;
  className?: string;
}

export function ComingSoon({ module, description, comingIn, features = [], children, className }: Props) {
  return (
    <div className={cn('space-y-6', className)}>
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight">{module}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{description}</p>
        </div>
        <span className="inline-flex items-center gap-1.5 rounded-full border border-primary/20 bg-primary/5 px-2.5 py-1 text-[0.7rem] font-medium uppercase tracking-wider text-primary">
          <Sparkles className="h-3 w-3" /> {comingIn}
        </span>
      </div>

      {children}

      {features.length > 0 && (
        <Card>
          <CardHeader><CardTitle>What's coming</CardTitle></CardHeader>
          <CardContent>
            <ul className="space-y-1.5 text-sm text-muted-foreground">
              {features.map((f) => (
                <li key={f} className="flex gap-2"><span className="text-primary">•</span><span>{f}</span></li>
              ))}
            </ul>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
